/**
 *  配电表计管理
 */
import * as HttpService from "../../../../service/HttpService";

/**
 * 查询表计管理列表
 */
export const queryMeterList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionMeter/meterList",params);
};

/**
 * 新增表计
 */
export const addMeter = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionMeter/addMeter", params);
};

/**
 * 编辑表计
 */
export const editMeter = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionMeter/editMeter", params);
};

/**
 * 编辑前根据ID获取详情
 */
export const getMeterDetailByTermId = (params) => {
    return HttpService.get(HttpService.DOMAIN + "/meterFiles/getMeterDetailByTermId?id="+params);
};

/**
 * 删除表计
 */
export const deleteMeter = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionMeter/deleteMeter", params);
};

/**
 *  批量导入新增
 */
export const bulkAdd = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionMeter/bulkAdd",params);
};

/**
 * 根据用能单位获取终端
 */
export const queryMeterByUnitId = (params) => {
    return HttpService.get(HttpService.DOMAIN + "/distributionMeter/queryMeterByUnitId?unitId="+params);
};
/**
 * 获取表计设备型号
 */
export const getMeterModelCode = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/distributionMeter/getMeterModelCode",params);
};
/**
 * 获取表计设备型号(加全部)
 */
export const getMeterModelCodeAll = () => {
    return HttpService.get(HttpService.DOMAIN + "/distributionMeter/getMeterModelCodeAll");
};
/**
 * 获取表计生产厂家
 */
export const getMeterMfrCode = () => {
    return HttpService.get(HttpService.DOMAIN + "/distributionMeter/getMeterMfrCode");
};
/**
 * 获取表计类型下拉列表
 */
export const getMeterTypeCode = () => {
    return HttpService.get(HttpService.DOMAIN + "/distributionMeter/getMeterTypeCode");
};
